import { ChangeDetectorRef, Component, ElementRef, EventEmitter, HostListener, Input, Output, SimpleChanges } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { ApiServiceModule } from 'src/app/back-office/modules/api-service.module';
import { HelperModule } from 'src/app/back-office/modules/helper.module';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import config from 'config/default.json';
import { TableComponent } from 'src/app/back-office/components/table/table.component';
import { DialogComponent } from 'src/app/back-office/components/dialog/dialog.component';
import { SharedService } from 'src/app/back-office/modules/shared-service.service';
import { SettingUserComponent } from './setting-user/setting-user.component';

@Component({
  selector: 'app-user-admin',
  templateUrl: './user-admin.component.html',
  styleUrls: ['./user-admin.component.scss', '../../components/table/table.component.scss']
})
export class UserAdminComponent extends TableComponent{
  constructor(
    private elRef:ElementRef,
    public cdRef: ChangeDetectorRef,
    public helper: HelperModule,
    public dialog: MatDialog,
    private apiService: ApiServiceModule,
    private sharedService: SharedService,
    public sanitizer: DomSanitizer) {
      super(sanitizer);
  }
  @Input() userInfos: { [x:string]: any } = new Map();
  countryData:{[x: string]: any}[] = [];
  functionData:{[x: string]: any}[] = [];
  navData = {limit: 20, offset: 0}
  

  userAuthorized:boolean = false;

  ngOnInit(): void {
    this.loadUserData();
  }
  loadUserData(){
    this.sharedService.sendData({in_progress: true});
    this.navData.offset = this.navIndex * this.navData.limit;
    this.apiService.queryData(config.master.ndapi.url + '/enovsky/web/administration/load_user', this.navData, this.userInfos['access_token']).subscribe((response:any)=>{
      this.countryData = response.countries;
      this.functionData = response.functions
      this.dataSource = response.users;
      this.showedRows = this.dataSource;
      this.totalRows = this.dataSource?.[0]?.total_rows ?? 0;
      this.totalNavigations = Math.ceil(this.totalRows / this.navData.limit);
      this.sharedService.sendData({in_progress: false});
    });
  }
  
  settingUser(){
    const dialogRef = this.dialog.open(SettingUserComponent, {
      maxWidth: '100vw',
              width: '95%',
              panelClass: 'full-screen-modal',
        position: {top: '30px' },
        data: {action: 'create_user', country: this.countryData, function: this.functionData, row_infos: null, user_infos: this.userInfos}
      });
      dialogRef.afterClosed().subscribe((response:any) => {
        
      });
  }
  updatePrivilege(row:any, element:any){
    row['privilege'] = element;
  }
  toggleUserAuthorized(row:any){
    row['authorized'] = !row['authorized'];
  }
  
  toggleRow(row:any, clickedElm:any, rowTab:any){
    let toExpand = true;
    for (var tdTab of rowTab.querySelectorAll('.to_skip_element')){
      if(tdTab.contains(clickedElm)){
        toExpand = false;
        break;
      }
    }
    if(toExpand){
      row['expanded'] =! row['expanded'];
    }
  }
  movePrevNextNavigation(action:string) {
    if (action == 'prev' && this.navIndex > 0) {
      this.navIndex--;
      this.loadUserData();
    }
    if (action == 'next' && this.navIndex < this.totalNavigations - 1) {
      this.navIndex++;
      this.loadUserData();
    }
  }
  applyFilterLocal(element:any, column:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applyFilter(element.value, column);
    this.cdRef.detectChanges();
  }
  applySortLocal(element:any, column:string, type:string){
    let tableBody = this.elRef.nativeElement.querySelector('tbody');
    this.removeDetailsRows(tableBody);
    this.applySort(element, column, type);
    this.cdRef.detectChanges();
  }
}
